(function() {
    let startTime = Date.now();
    let totalActiveTime = 0;
    let lastActiveTime = Date.now();
    let isIdle = false;
    let idleTimeout;
    
    const IDLE_THRESHOLD = 5000; // 5 seconds of no activity = idle
    const SYNC_INTERVAL = 10000; // Send data every 10s

    function getSlug() {
        const path = window.location.pathname.replace(/\/$/, '');
        const parts = path.split('/');
        return parts[parts.length - 1] || 'home';
    }

    function resetIdle() {
        if (isIdle) {
            isIdle = false;
            lastActiveTime = Date.now();
        }
        clearTimeout(idleTimeout);
        idleTimeout = setTimeout(() => {
            isIdle = true;
            // Add accumulated time before going idle
            totalActiveTime += (Date.now() - lastActiveTime);
        }, IDLE_THRESHOLD);
    }

    // Activity listeners
    ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'].forEach(evt => {
        window.addEventListener(evt, resetIdle, { passive: true });
    });

    // Initial trigger
    resetIdle();

    const API_BASE = '/api/analytics';

    // 1. Send View Event immediately
    function recordView() {
        const data = {
            slug: getSlug(),
            event: 'view',
            timestamp: new Date().toISOString()
        };
        fetch(`${API_BASE}/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            keepalive: true
        }).catch(() => {});
    }

    // 2. Fetch and Update View Count
    function updateViewCount() {
        const slug = getSlug();
        fetch(`${API_BASE}/stats?slug=${slug}`)
            .then(response => response.json())
            .then(data => {
                if (data && data.views !== undefined) {
                    const viewElements = document.querySelectorAll('.gh-article-meta-views');
                    viewElements.forEach(el => {
                        // Keep the icon if present (it's usually an SVG inside)
                        const icon = el.querySelector('svg');
                        if (icon) {
                            el.innerHTML = '';
                            el.appendChild(icon);
                            el.appendChild(document.createTextNode(` ${data.views} views`));
                        } else {
                            el.textContent = `${data.views} views`;
                        }
                    });
                }
            })
            .catch(() => {});
    }

    // Run on load
    recordView();
    updateViewCount();

    function sendData(isFinal = false) {
        // Calculate pending active time if not currently idle
        let currentSessionActive = totalActiveTime;
        if (!isIdle) {
            currentSessionActive += (Date.now() - lastActiveTime);
        }

        const data = {
            slug: getSlug(),
            event: 'engagement',
            timeOnPageMs: Date.now() - startTime,
            activeTimeMs: currentSessionActive,
            isFinal: isFinal
        };

        // Use sendBeacon if closing, otherwise fetch
        const url = `${API_BASE}/track`;
        
        if (isFinal && navigator.sendBeacon) {
            const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
            navigator.sendBeacon(url, blob);
        } else {
            fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
                keepalive: true
            }).catch(() => {}); // Ignore errors (e.g. server offline)
        }
    }

    setInterval(() => sendData(false), SYNC_INTERVAL);

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            sendData(false);
        }
    });

    window.addEventListener('beforeunload', () => {
        sendData(true);
    });
})();
